import { takeEvery } from "redux-saga/effects";
import {
  SUBMIT_PLAYER_PURCHASE,
  SUBMIT_PLAYER_PURCHASE_STRIPE
} from "../../state/purchase/constants";
import submitPurchase from "./submit-purchase";
import submitPurchaseStripe from "./submit-purchase-stripe";

function* purchase() {
  yield takeEvery(SUBMIT_PLAYER_PURCHASE, submitPurchase);
  yield takeEvery(SUBMIT_PLAYER_PURCHASE_STRIPE, submitPurchaseStripe);
}

export default purchase;
